<template>
  <div>
    <b-card>
      <span class="d-block font-weight-500 font-size-18">
        Customer Permission
      </span>
      <span
        v-if="isDisableAllPermission"
        class="d-block font-size-12 text-color-danger"
      >
        * At least 1 permission must be enable.
      </span>
      <molecule-permission-card
        v-model="currentPermissionList"
      ></molecule-permission-card>
    </b-card>
    <div class="button-section d-flex justify-content-end">
      <atom-button
        buttonId="save-customer-permission"
        class="mr-1"
        :isDisable="saveChangesButtonDisableControl"
        @click="clickSaveChangeCustomerPermission"
        >Save Change
      </atom-button>
      <atom-button
        buttonId="cancel-customer-permission"
        buttonStyle="border"
        buttonColor="secondary"
        @click="clickCancelEditCustomerPermission"
        >Cancel
      </atom-button>
    </div>

    <molecule-modal-dialog
      modalId="modal-confirm-edit-customer-permission"
      buttonTextLeft="Save Changes"
      :isTextCenter="true"
      :textTitle="`Do you want to Save Change?`"
      @clickButtonLeft="clickConfirmSaveChanges"
      @clickButtonRight="clickCloseModal"
    >
    </molecule-modal-dialog>
    <molecule-modal-dialog
      modalId="modal-confirm-discard-change-customer-permission"
      textTitle="Do you want to leave without finishing?"
      buttonTextLeft="Confirm"
      :isTextCenter="true"
      @clickButtonLeft="clickConfirmDiscard"
      @clickButtonRight="clickCloseModal"
    >
    </molecule-modal-dialog>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculePermissionCard from "@/components/molecules/globalSetting/userManagement/MoleculePermissionCard.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
export default {
  name: "OrganismCustomerPermission",

  components: {
    BCard,
    AtomButton,
    MoleculePermissionCard,
    MoleculeModalDialog,
  },

  mixins: [mixinsObjectHelper],

  props: {
    originPermissionList: {
      type: Array,
      required: true,
    },
    updatePermissionFunc: {
      type: Function,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      modalId: null,
    }
  },

  computed: {
    currentPermissionList: {
      get() {
        return this.value
      },
      set(value) {
        this.emit("input", value)
      },
    },
    isDataChange() {
      return this.compareIsChangeArray(
        this.originPermissionList,
        this.currentPermissionList
      )
    },
    isDisableAllPermission() {
      return this.currentPermissionList.every((page) =>
        page.permissions.every((permission) => !permission.enable)
      )
    },
    saveChangesButtonDisableControl() {
      return !this.isDataChange || this.isDisableAllPermission
    },
  },

  methods: {
    openModal(id) {
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    clickSaveChangeCustomerPermission() {
      this.openModal("modal-confirm-edit-customer-permission")
    },

    clickConfirmSaveChanges() {
      this.updatePermissionFunc()
      this.closeModal()
    },

    clickCancelEditCustomerPermission() {
      if (this.isDataChange) {
        this.openModal("modal-confirm-discard-change-customer-permission")
      } else {
        this.navigateTo("/global-settings")
        this.closeModal()
      }
    },

    clickConfirmDiscard() {
      this.navigateTo("/global-settings")
      this.closeModal()
    },

    clickCloseModal() {
      this.closeModal()
    },
  },
}
</script>

<style lang="scss" scoped></style>
